"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Label;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Label(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("title", null, "icon"), /*#__PURE__*/_react["default"].createElement("g", {
    id: "General"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "label"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "outline-5",
    "data-name": "outline"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M52.137,92.5a3.944,3.944,0,0,1-2.808-1.162L12.936,54.944a3.834,3.834,0,0,1-.8-1.166,6.861,6.861,0,0,1-1.013-3.589V21.671a6.919,6.919,0,0,1,6.911-6.911H46.555a6.854,6.854,0,0,1,3.527.979,3.817,3.817,0,0,1,1.236.823L87.713,52.956h0a3.976,3.976,0,0,1,0,5.613L54.944,91.339A3.943,3.943,0,0,1,52.137,92.5Zm-35.5-40.924,35.5,35.5L83.449,55.763,47.966,20.28a2.572,2.572,0,0,1-.376-.2,1.879,1.879,0,0,0-1.035-.317H18.037a1.913,1.913,0,0,0-1.911,1.911V50.189a1.884,1.884,0,0,0,.321,1.048A2.455,2.455,0,0,1,16.638,51.576Zm.091.223h0ZM48.193,20.366Z"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "29.56",
    cy: "31.965",
    r: "4.41"
  })))));
}